<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { ModelListSelect } from "vue-search-select";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Sales Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE",
        },
        {
          key: "identification",
          sortable: true,
          label: "IDENTIFICATION",
        },
        {
          key: "user",
          sortable: true,
          label: "USER",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      unhold: {
        id: "",
      },
      deleteholddata: {
        id: "",
      },
      add: {
        id: "",
        quantity_taken: "",
        product: "",
        unit: "",
        quantity: 1,
        instock: "",
        type: "",
      },
      unitsArr: [],
      qtyError: "",
      unitError: "",
      itemError: "",
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["SaveStatus","Sales"]),
    ...mapGetters("sales", ["SaveStatus","AllSaleHeld","Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.AllSaleHeld ? this.AllSaleHeld.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllSaleHeld ? this.AllSaleHeld.length : 1;
  },
  updated() {
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchSalesHeld: "sales/fetchAllHeld",
      FetchProducts: "sales/fetchItems",
      AddCart1: "sales/addToCart1",
      UnHold: "sales/unHoldSale",
      AddOrder: "sales/addHold",
      DeleteHold: "sales/deleteHold",
      EditPaid: "saledetails/editAmtPaidMode",
      EditSale: "saledetails/editSale",
      DeleteSale: "saledetails/deleteSale",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    assignArr2(){
        let selectedPdt = this.Products.filter((product)=>{
            return product.id == this.add.product;
        })
        this.unitsArr = selectedPdt[0].units;
        this.add.type = selectedPdt[0].type;
        this.add.unit = this.unitsArr[0].id;
        this.add.instock = selectedPdt[0].instock;
    },

    validateQty2(){
        if(this.add.product && this.add.quantity && this.add.unit && this.add.type==1){
            let tot = this.unitsArr.filter((unit)=>{
                return unit.id == this.add.unit;
            });
            let totEqv = tot[0].base_qty*this.add.quantity;
            if(totEqv > this.add.instock){
                this.qtyError = "Quantity Out Of Range";
                return;
            }
            else{
                this.qtyError = "";
            }
        }
    },

    resetErrors() {
        this.itemError = "";
        this.unitError = "";
        this.qtyError = "";
    },

    resetModal() {
        this.add.id = "";
    this.add.product = "";
    this.add.quantity = "";
    this.add.unit = "";
    },

    showDeleteModal(data) {
      this.deletedata.name = data.name;
      this.deletedata.id = data.id;
    },
    showAddModal(data) {
      this.add.id = data.id;
    },
    showUnHoldModal(data) {
      this.unhold.id = data.id;
    },
    showDeleteHoldModal(data) {
      this.deleteholddata.id = data.id;
    },
    resetDeleteItem() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    addToCart1(model) {
      this.modal_id = model;
      if (this.add.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.add.quantity == "") {
        this.qtyError = "Quantity is required";
        return;
      } else {
        this.qtyError = "";
      }
      this.validateQty2();
      this.AddCart1(this.add);
    },
    UnHoldOrder(mod){
      this.modal_id = mod;
      this.UnHold(this.unhold);
    },
    deleteHeldItem(mod){
      this.modal_id = mod;
      this.DeleteHold(this.deleteholddata);
    },

    redirect(value) {
      this.$router.push(
        `/hold/print/${btoa(value)}`
      );
    },

    closeModal(modalId) {
      this.resetErrors();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

  },
  created() {
    this.FetchSalesHeld();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Held Sales Report</h4>
              </div>
              <div class="col-md-3" align="right">
                  <button size="sm" @click="$router.go(-1)" class="btn btn-primary mb-2">
                        <i class="fas fa-arrow-circle-left"></i> Go Back
                    </button>
              </div>

            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="AllSaleHeld?AllSaleHeld:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(amt_paid)="data">
                  <span class="text-warning" 
                  v-b-modal.expired-modal
                    @click="ShowEdit(data.item)" v-if="data.item.numpaid<0">
                    {{ thousandSeperator(data.item.totalPaid) }}
                    </span>
                    <span v-else>
                    {{ thousandSeperator(data.item.totalPaid) }}
                    </span>
                </template>
                <template #cell(discount_field)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(actions)="data">
                    <b-button-group>
                  <b-button
                    v-b-modal.unhold-item-modal
                    variant="success"
                    size="sm"
                    @click="showUnHoldModal(data.item)"
                    ><i class="fa fa-undo"></i>UnHold</b-button
                  >
                  <b-button
                    v-b-modal.add-item-modal
                    variant="info"
                    size="sm"
                    @click="showAddModal(data.item)"
                    ><i class="fa fa-plus"></i>Add</b-button
                  >
                  <b-button
                    size="sm"
                    variant="primary"
                    @click="redirect(data.item.id)"
                    ><i class="fa fa-print"></i> Print</b-button
                  >
                  <b-button
                    v-b-modal.delete-hold-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteHoldModal(data.item)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  </b-button-group>
                        
                </template>
                <template #cell(details)="data">
                  <table  class="table">
                    <tbody>
                    <tr v-for="(det,d) in data.item.items" :key="d" width="100%">
                      <td>{{ det.name }}</td>
                      <td>{{ det.quantity }}{{ det.unit }}</td>
                      <td>{{ det.selling?thousandSeperator(det.selling):0 }}</td>
                      <td>{{ det.selling?thousandSeperator(det.selling*det.quantity):0 }}</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
            </div>
            
            <Loader  v-if="!AllSaleHeld"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

        <!-- modal delete expense starts -->
    <b-modal id="unhold-item-modal" hide-footer>
      <template #modal-title class="text-danger">UnHold Order</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Are you sure you want to UnHold this Order?.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('unhold-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="UnHoldOrder('unhold-item-modal')"
        >
          <i class="fa fa-check"></i> UnHold
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="UnHolding"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
        <!-- modal delete expense starts -->
    <b-modal id="delete-hold-item-modal" hide-footer>
      <template #modal-title class="text-danger"> Delete Held Order</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to this Order? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-hold-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteHeldItem('delete-hold-item-modal')"
        >
          <i class="fa fa-trash"></i> Delete
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal for adding items -->
    <b-modal id="add-item-modal" hide-footer @hidden="resetModal()">
      <template #modal-title class="text-primary">
        Add Item to this Order</template
      >
      <div class="form-group mb-3">
          <label>Product <span class="text-danger">*</span></label>
          <model-list-select
          :list="Products ? Products : []"
          v-model="add.product"
          option-value="id"
          option-text="name2"
          placeholder="Select Product"
          @input="resetErrors(),assignArr2()"
          >
          </model-list-select>
          <div class="text-danger" v-if="itemError">
          <em>{{ itemError }}</em>
          </div>
      </div>
      <div class="row">
        <div class="col-md-6">
            <div class="form-group mb-3">
              <label>Quantity</label>
              <input
                type="number"
                class="form-control"
                step="any"
                v-model="add.quantity"
                @keyup.enter="addToCart1()"
                @input="resetErrors(),validateQty2()"
              />
            </div>
            <div class="text-danger" v-if="qtyError">
              <em>{{ qtyError }}</em>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label>Unit Measure <span class="text-danger">*</span></label>
                <model-list-select
                :list="unitsArr ? unitsArr : []"
                v-model="add.unit"
                option-value="id"
                option-text="unitsym"
                placeholder="Unit"
                @input="resetErrors()"
                @keyup.enter="addToCart1()"
                >
                </model-list-select>
                <div class="text-danger" v-if="unitError">
                  <em>{{ unitError }}</em>
                </div>
            </div>
        </div>

      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addToCart1('add-item-modal')"
        >
          <i class="fa fa-plus"></i> Add Item
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Adding"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
